import React, {useEffect, useState, useContext} from 'react';
import {
    getAppSettingsForCompany,
    getGeneralSettingsForCompany,
    updateAppSettingsForCompany,
    updateGeneralSettingsForCompany
} from "../../API/companyApi";
import useCompanyId from "../../Hooks/useCompanyId";
import {toast} from "react-toastify";
import messageFromError from "../../utils/errorUtils";
import {useTranslation} from "react-i18next";
import useClaims from "../../Hooks/useClaims";
import {SET_GLOBAL_SETTINGS} from "../../Claims";
import SettingsContainer from "./Components/SettingsContainer";
import {SalvoContext} from "../../contexts/SalvoContext";

const SettingsPage = () => {

    const [appSettings, setAppSettings] = useState()
    const [generalSettings, setGeneralSettings] = useState()
    const [isUpdatingSettings, setIsUpdatingSettings] = useState(false)
    const { refreshGeofenceProjectReference } = useContext(SalvoContext);


    const {t} = useTranslation()
    const companyId = useCompanyId()
    const {hasClaim, isLoading} = useClaims();

    useEffect(() => {
        async function fetchAppSettings() {
            const response = await getAppSettingsForCompany(companyId)
            setAppSettings(removeSuperAdminSettings(response.data));
        }

        async function fetchGeneralSettings() {
            const response = await getGeneralSettingsForCompany(companyId)
            setGeneralSettings(removeSuperAdminSettings(response.data));
        }

        function removeSuperAdminSettings(settings) {

            if(hasClaim(SET_GLOBAL_SETTINGS)) // If the user can set global settings, they can see all settings.
            {
                return settings
            }

            const superAdminSettingKeys = [
                "GEOFENCE_ENLARGEMENT_METERS"
            ]

            return settings.filter(setting => !superAdminSettingKeys.includes(setting.key))
        }

        if(companyId && !isLoading)
        {
            fetchAppSettings()
            fetchGeneralSettings()
        }

    }, [companyId, isLoading]);

    const updateSettings = async (settings, appOrGeneral = "app") => {
        setIsUpdatingSettings(true)

        try {
            if(appOrGeneral === "app")
            {
                await updateAppSettingsForCompany(companyId, settings)
            }
            else {
                await updateGeneralSettingsForCompany(companyId, settings)
                await refreshGeofenceProjectReference?.(); 
            }
            toast.success('Settings updated successfully')
        }
        catch(error)
        {
            toast.error(messageFromError(error))
        }
        finally {
            setIsUpdatingSettings(false)
        }
    }

    return <SettingsContainer appSettings={appSettings} generalSettings={generalSettings} isUpdatingSettings={isUpdatingSettings} updateSettings={updateSettings}/>;
};

export default SettingsPage;